__turbopack_context__.v({
  "body": "modal-module__T5xzHG__body",
  "head": "modal-module__T5xzHG__head",
  "modal-fade": "modal-module__T5xzHG__modal-fade",
  "page": "modal-module__T5xzHG__page",
  "settled": "modal-module__T5xzHG__settled",
  "toolbar": "modal-module__T5xzHG__toolbar",
});
